import {HttpErrorResponse, HttpResponseBase} from "@angular/common/http";
import {Feildata, TypetValideringsfeilModell, TypetValideringsresultatModell} from "felles-ng2/tjenester/ressurser/ng2HttpKlientTilleggstyper";
import {OpplastetDokumentVersjonValideringsfeil} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {HttpResponskoder, ikkeTilgangTilEntitetExceptions} from "./httpResponskoder";


export function erIkkeTilgangTilEntitetException(statuskode: number): boolean {
    return ikkeTilgangTilEntitetExceptions.includes(statuskode);
}

export function erHttpErrorResponse(feil: any): feil is HttpErrorResponse {
    return feil instanceof HttpErrorResponse;
}

export function erValideringsfeilException<T = any, D = Feildata>(feil: any): feil is ValideringsfeilException<T, D> {
    return erHttpErrorResponse(feil) && feil.status == HttpResponskoder.ValideringsfeilException;
}

export function erValideringsfeilExceptionMedFeilkode<T, D = Feildata>(feil: any, feilkode: string): feil is ValideringsfeilException<T, D> {
    return erValideringsfeilException(feil) && feil.error.feil.some(feil => feil.feilkode == feilkode)
}

export function erValideringsfeilUgyldigMimeformat(feil: any): feil is ValideringsfeilException<OpplastetDokumentVersjonValideringsfeil.ugyldig_mimeformat, { mimetype: string }> {
    return erValideringsfeilExceptionMedFeilkode(feil, OpplastetDokumentVersjonValideringsfeil.ugyldig_mimeformat);
}


export function finnValideringsfeilMedFeilkode(feil: any, feilkode: OpplastetDokumentVersjonValideringsfeil.ugyldig_mimeformat): UgyldigMimeformatFeil | null;
export function finnValideringsfeilMedFeilkode<T, D = Feildata>(feil: any, feilkode: T): TypetValideringsfeilModell<T, D> | null;
export function finnValideringsfeilMedFeilkode<T, D = Feildata>(feil: any, feilkode: T): TypetValideringsfeilModell<T, D> | null {
    return erValideringsfeilException<T, D>(feil) ?
      feil.error.feil.find(kandidat => kandidat.feilkode == feilkode) ?? null :
      null
}

type UgyldigMimeformatFeil = TypetValideringsfeilModell<OpplastetDokumentVersjonValideringsfeil.ugyldig_mimeformat, { mimetype: string }>

export type ValideringsfeilException<T = any, D = Feildata> = HttpResponseBase & { error: TypetValideringsresultatModell<T, D> }

